import { render, staticRenderFns } from "./linkedcomponent.vue?vue&type=template&id=4b483866"
import script from "./linkedcomponent.vue?vue&type=script&lang=ts"
export * from "./linkedcomponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports